import React, { useEffect, useRef } from 'react'
import { DeviceTileProps } from '../../lib/type'
import Image from '@corratech/pylot-image'
import s from '@components/common/ProductTile/ProductTile.module.scss'
import ds from './DeviceTile.module.scss'
import cn from 'classnames'
import Price from 'stores/ooka_usa_store/airglobal/pylot-custom-kit-flow/src/Components/Price/Price'

export const DeviceTile = ({
    option,
    device,
    selectedOptions,
    setSelectedOptions,
    isDevice
}: DeviceTileProps): JSX.Element => {
    const product = option?.product
    const image = product?.thumbnail

    const isPreselected = useRef(false)

    useEffect(() => {
        if (!isDevice && !isPreselected.current) {
            isPreselected.current = true
            setSelectedOptions?.((oldState) => [
                ...oldState,
                option?.uid as string
            ])
        }
    }, [isDevice, option])

    const handleDeviceClick = (uid = '') => {
        if (!setSelectedOptions) return

        const existingDevice = device?.options?.find((deviceItem) =>
            selectedOptions?.includes(deviceItem?.uid!)
        )

        if (existingDevice) {
            // click on selected device
            setSelectedOptions((state) =>
                state.filter((item) => item !== existingDevice?.uid)
            )
            if (existingDevice.uid !== uid) {
                setSelectedOptions((state) => [...state, uid])
            }
            return
        }

        setSelectedOptions((state) => [...state, uid])
    }

    const isOOS = product?.stock_status === 'OUT_OF_STOCK'

    return (
        <div
            tabIndex={0}
            role="button"
            className={cn(
                s['productitem-block'],
                ds['productitem-block'],
                isDevice && selectedOptions?.includes(option?.uid!)
                    ? ds['selected']
                    : '',
                !isDevice && ds['productitem-block--pod'],
                isOOS ? ds['oos-device'] : ''
            )}
            onClick={() => {
                if (!isOOS && isDevice) {
                    handleDeviceClick(option?.uid)
                }
            }}
        >
            <div className={cn(['productimage-block'])}>
                <div
                    className={cn(
                        s['productimg-link'],
                        'product-card-image-swipe',
                        'slider-product-img'
                    )}
                >
                    <Image
                        src={image?.url!}
                        alt={option?.label!}
                        width={isDevice ? 390 : 100}
                        height={isDevice ? 390 : 100}
                        className={s['product-img']}
                    />
                </div>
            </div>
            <div className={cn(s['plp-prod-details'], 'sliderproduct-detail')}>
                <h5
                    className={cn(
                        'product-name uppercase text-base leading-extra-4.4 font-ookaParagraph font-semibold tracking-extra-base md:leading-5'
                    )}
                    title={option?.label!}
                >
                    {option?.label}
                </h5>
                <div className={ds['short-description']}>
                    {option?.product?.short_description?.html}
                </div>
                {!isDevice ? (
                    ''
                ) : (
                    <div>
                        <Price product={option?.product!} />
                    </div>
                )}
            </div>
        </div>
    )
}

export default DeviceTile
